export const darkTheme = {
  bgPrimary: '#0a0a0a',
  bgSecondary: '#111111',
  bgTertiary: '#1a1a1a',
  bgElevated: '#181818',

  textPrimary: '#ffffff',
  textSecondary: 'rgba(255, 255, 255, 0.75)',
  textTertiary: 'rgba(255, 255, 255, 0.55)',
  textMuted: 'rgba(255, 255, 255, 0.35)',

  borderDefault: 'rgba(255, 255, 255, 0.08)',
  borderHover: 'rgba(255, 255, 255, 0.16)',
  borderStrong: 'rgba(255, 255, 255, 0.24)',

  accentGreen: '#22c55e',
  accentGreenHover: '#16a34a',
  accentGreenSubtle: 'rgba(34, 197, 94, 0.08)',
  accentGreenBorder: 'rgba(34, 197, 94, 0.22)',

  danger: '#dc2626',
  dangerSubtle: 'rgba(220, 38, 38, 0.10)',
  warning: '#f59e0b',
  warningSubtle: 'rgba(245, 158, 11, 0.10)',

  codeBg: '#0d0d0d',
  codeBorder: 'rgba(255, 255, 255, 0.06)',
};

export const lightTheme = {
  bgPrimary: '#fafafa',
  bgSecondary: '#ffffff',
  bgTertiary: '#f4f4f5',
  bgElevated: '#ffffff',

  textPrimary: '#0a0a0a',
  textSecondary: 'rgba(10, 10, 10, 0.75)',
  textTertiary: 'rgba(10, 10, 10, 0.55)',
  textMuted: 'rgba(10, 10, 10, 0.40)',

  borderDefault: 'rgba(10, 10, 10, 0.08)',
  borderHover: 'rgba(10, 10, 10, 0.16)',
  borderStrong: 'rgba(10, 10, 10, 0.24)',

  accentGreen: '#16a34a',
  accentGreenHover: '#15803d',
  accentGreenSubtle: 'rgba(22, 163, 74, 0.08)',
  accentGreenBorder: 'rgba(22, 163, 74, 0.22)',

  danger: '#dc2626',
  dangerSubtle: 'rgba(220, 38, 38, 0.08)',
  warning: '#d97706',
  warningSubtle: 'rgba(217, 119, 6, 0.10)',

  codeBg: '#fafafa',
  codeBorder: 'rgba(10, 10, 10, 0.06)',
};
